import { createIcon } from '@mote/ui/components/icon'

export const RectangleClassRoomIcon = createIcon({
  displayName: 'RectangleClassRoomIcon',
  path: [
    <path d='M1.818 2.037h16.364v13.926H1.818V2.037Z' fill='#0F9D58' />,
    <path
      d='M13.636 9.464c.565 0 1.023-.468 1.023-1.044 0-.577-.458-1.045-1.023-1.045-.564 0-1.022.468-1.022 1.045 0 .576.458 1.044 1.022 1.044Zm0 .697c-1.094 0-2.272.591-2.272 1.326v.762h4.545v-.762c0-.735-1.178-1.326-2.273-1.326Zm-7.272-.697c.564 0 1.022-.468 1.022-1.044 0-.577-.458-1.045-1.022-1.045-.565 0-1.023.468-1.023 1.045 0 .576.458 1.044 1.023 1.044Zm0 .697c-1.095 0-2.273.591-2.273 1.326v.762h4.545v-.762c0-.735-1.178-1.326-2.272-1.326Z'
      fill='#57BB8A'
    />,
    <path
      d='M10 8.536c.754 0 1.364-.623 1.364-1.393S10.754 5.75 10 5.75c-.753 0-1.363.623-1.363 1.393S9.247 8.536 10 8.536Zm0 .928c-1.534 0-3.181.832-3.181 1.857v.928h6.363v-.928c0-1.025-1.648-1.857-3.182-1.857Z'
      fill='#F7F7F7'
    />,
    <path d='M11.819 15.035h4.09v.928h-4.09v-.928Z' fill='#F1F1F1' />,
    <path
      d='M18.636.18H1.364C.61.18 0 .803 0 1.573v14.854c0 .77.61 1.393 1.364 1.393h17.272c.754 0 1.364-.623 1.364-1.393V1.573C20 .803 19.39.18 18.636.18Zm-.454 15.783H1.818V2.037h16.364v13.926Z'
      fill='#F4B400'
    />,
    <path
      opacity='.2'
      d='M18.636.18H1.364C.61.18 0 .803 0 1.573v.116C0 .919.61.296 1.364.296h17.272C19.39.296 20 .919 20 1.689v-.116C20 .803 19.39.18 18.636.18Z'
      fill='#fff'
    />,
    <path
      opacity='.2'
      d='M18.636 17.704H1.364C.61 17.704 0 17.081 0 16.311v.117c0 .77.61 1.392 1.364 1.392h17.272c.754 0 1.364-.623 1.364-1.392v-.117c0 .77-.61 1.393-1.364 1.393Z'
      fill='#BF360C'
    />,
    <path
      d='M15.902 15.963H11.81l1.818 1.857h4.087l-1.814-1.857Z'
      fill='url(#a)'
    />,
    <path
      opacity='.2'
      d='M1.819 1.92h16.363v.117H1.82v-.116Z'
      fill='#263238'
    />,
    <path opacity='.2' d='M1.819 15.963h16.363v.116H1.82v-.116Z' fill='#fff' />,
    <path
      d='M18.636.18H1.364C.61.18 0 .803 0 1.573v14.854c0 .77.61 1.393 1.364 1.393h17.272c.754 0 1.364-.623 1.364-1.393V1.573C20 .803 19.39.18 18.636.18Z'
      fill='url(#b)'
    />,
    <defs>
      <radialGradient
        id='b'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(82.5197 0 0 84.2751 .589 .593)'
      >
        <stop stopColor='#fff' stopOpacity='.1' />
        <stop offset='1' stopColor='#fff' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='a'
        x1='14.764'
        y1='15.989'
        x2='14.764'
        y2='17.839'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#BF360C' stopOpacity='.2' />
        <stop offset='1' stopColor='#BF360C' stopOpacity='.02' />
      </linearGradient>
    </defs>
  ],
  viewBox: '0 0 20 18',
  defaultProps: {
    fill: 'none',
    width: '20px',
    height: '18px'
  }
})
